var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCircleReadIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4997 20.8335C17.102 20.8335 20.833 17.1025 20.833 12.5002C20.833 7.89779 17.102 4.16683 12.4997 4.16683C7.8973 4.16683 4.16634 7.89779 4.16634 12.5002C4.16634 17.1025 7.8973 20.8335 12.4997 20.8335ZM12.4997 22.9168C18.2526 22.9168 22.9163 18.2531 22.9163 12.5002C22.9163 6.7472 18.2526 2.0835 12.4997 2.0835C6.74671 2.0835 2.08301 6.7472 2.08301 12.5002C2.08301 18.2531 6.74671 22.9168 12.4997 22.9168Z",
    fill: "#0078FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4997 7.2915C11.9244 7.2915 11.458 7.75787 11.458 8.33317C11.458 8.90847 11.9244 9.37484 12.4997 9.37484C13.075 9.37484 13.5413 8.90847 13.5413 8.33317C13.5413 7.75787 13.075 7.2915 12.4997 7.2915ZM12.4997 11.4582C11.9244 11.4582 11.458 11.9245 11.458 12.4998V16.6665C11.458 17.2418 11.9244 17.7082 12.4997 17.7082C13.075 17.7082 13.5413 17.2418 13.5413 16.6665V12.4998C13.5413 11.9245 13.075 11.4582 12.4997 11.4582Z",
    fill: "#0078FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleReadIcon);
export default __webpack_public_path__ + "static/media/CircleReadIcon.0246b948.svg";
export { ForwardRef as ReactComponent };